<template>
  <div id="atm-work" class="container">
    <main class="main-content">
      <article class="main">
        <QuickLink />
      </article>
      <article class="sub" style="padding-top: 0;">
        <template v-if="getAtmCollectStep === 1">
          <template v-if="isEmpty(getStoreAtmInfo)">
            <div style="display: flex; justify-content: center; margin-top: 20px;">
            <div style="display: flex; align-items: center;">
              <DxTextBox
              placeholder="배송처코드를 입력하세요"
                fontSize="20px"
                height="35px"
                width="100%"
                v-model="dlvdId"
                :onEnterKey="gotDlvdId"
              />
            </div>
            <button
              class="btn btn_type_01 font13"
              @click="gotDlvdId" style="margin-left: 5px; margin-right: 5px;"
            >
              조회
            </button>
            <button
              class="btn btn_type_01 font13"
              @click="readQr" style="margin-left: 5px; margin-right: 5px;"
            >
              QR코드 조회
            </button>
            </div>
          </template>
        </template>
        <!-- <template v-if="getAtmCollectStep === 2">
          <div class="grid-container">
            <div style="grid-column: 1 / 3;">
              <DxTextBox
                :readOnly="true"
                fontSize="20px"
                height="35px"
                v-model="getStoreAtmInfo.dlvd_id"
              />
            </div>
            <div style="display: flex; justify-content: center;">
              <button
                class="btn btn_type_01 font13"
                @click="handleOpenAtmClick"
              >
                수납함 열림
              </button>
            </div>
          </div>
        </template> -->
        <template v-if="getAtmCollectStep === 2">
          <template v-if="isEmpty(getStoreAtmInfo)">
            <QrReader
              ref="qrReader"
              msg="QR 코드를 잡아주세요."
              @captureQrData="gotQrAtmId"
            />
          </template>
          <br />
          <div class="taC">
            <br />
            <button class="btn btn_type_01" @click="activeCamera">촬영</button>
            <button class="btn btn_type_01" @click="cancleCamera">취소</button>
          </div>
        </template>
        <template v-if="getAtmCollectStep === 3">
          <List
            :releaseList="releaseList"
            :atmName="getStoreAtmInfo.atm_name"
            @callCollectApi="callCollectApi"
            @imageUpload="handleImageUpload"
          />
        </template>
      </article>
    </main>
  </div>
</template>

<script>
import QuickLink from '@/components/QuickLink.vue'
import QrReader from '@/components/QrReader.vue'
import List from './list.vue'
import isEmpty from 'lodash/isEmpty'
import DxTextBox from 'devextreme-vue/text-box'

export default {
  name: 'NormalCollect',
  components: {
    QuickLink,
    List,
    DxTextBox,
    QrReader
  },
  data: () => ({
    releaseList: [],
    filesReders: [],
    files: [],
    dlvdId:''
  }),
  computed: {
    getErrMsg () {
      return window.$store.getters['AtmWsStore/getErrMsg']
    },
    getStoreNormalAtmId () {
      return window.$store.getters['AtmWsStore/getReqNormalAtmId']
    },
    getStoreAtmInfo () {
      return window.$store.getters['AtmWsStore/getResNormalAtmInfo']
    },
    getAtmCollectStep () {
      return window.$store.getters['AtmWsStore/getAtmCollectStep']
    },
    getJobStartDateTime () {
      return window.$store.getters['AtmWsStore/getJobStartDateTime']
    },
    getDoorOpenDateTime () {
      return window.$store.getters['AtmWsStore/getDoorOpenDateTime']
    },
    getStoreResultAtmInfoId () {
      return window.$store.getters['AtmWsStore/getResultAtmInfoId']
    },
    getRoutePath () {
      return this.$route.path
    }
  },
  created () {
    if (this.getAtmCollectStep !== 1) {
      this.stepAction(this.getAtmCollectStep)
    }
  },
  mounted () {
    document.getElementsByClassName('top')[0].hidden = true
  },
  beforeDestroy () {
    document.getElementsByClassName('top')[0].hidden = false
  },
  watch: {
    getAtmCollectStep (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.stepAction(newVal)
      }
    },
    getRoutePath (newVal, oldVal) {
      if (newVal !== oldVal && newVal === '/normal/collect') {
        console.log('route path')
        this.init()
      }
    }
  },
    beforeRouteLeave(to, from, next) {
      console.log('[Route Leave] from:', from.path, '→ to:', to.path)
      this.$store.commit('AtmWsStore/stateResetInit')
      next()
  },
  methods: {
    isEmpty,
    init () {
      this.setStoreAtmId('')
    },
    gotDlvdId () {
      const atmId = this.dlvdId;
      this.setStoreAtmId(atmId)
    },
    gotQrAtmId(atmId){
      this.setStoreAtmId(atmId+'QR_ID')
    },
    setStoreAtmId (atmId) {
      this.$store.commit('AtmWsStore/setReqNormalAtmId', atmId)
    },
    setStoreAtmInfo (atmInfo) {
      this.$store.commit('AtmWsStore/setResNormalAtmInfo', atmInfo)
    },
    setStoreAtmCollectStep (step) {
      this.$store.commit('AtmWsStore/setAtmCollectStep', step)
    },

    stepAction (step) {
      switch (step) {
        case 1:
          this.setStoreAtmId('')
          break
        case 3:
          this.getreleaseList()
          break
      }
    },
    readQr(){
       setTimeout(() => {
        this.$refs.qrReader.activeCamera()
      }, 100)
      this.setStoreAtmCollectStep(2)
    },
    cancleCamera(){
      this.setStoreAtmCollectStep(1)
    },
    activeCamera () {
      this.setStoreAtmId('')
      this.$refs.qrReader.activeCamera()
    },
    noticeToAtm (params) {
      return window.$store.dispatch('AtmWsStore/noticeToAtm', params)
    },
    async handleOpenAtmClick () {
      const res = await this.noticeToAtm({ atmId: this.getStoreNormalAtmId, jobDvsnCode: 'door_open' })
      if (res) {
        const { data: { status, result } } = res
        if (status === '200' && result === 200) {
          this.setStoreAtmCollectStep(3)
        } else {
          this.$Alert.alert(this.getErrMsg[result]).then(() => {
            this.setStoreAtmInfo({})
            this.setStoreAtmId('')
            this.setStoreAtmCollectStep(1)
          })
        }
      }
    },
    async getreleaseList () {
      const res = await this.$http.get(`/api/purchase/atm/release/${this.getStoreResultAtmInfoId}`)

      if (res) {
        const { data: { status, result } } = res
        if (status === '200') {
          const { resList } = result
          this.$store.commit('AtmWsStore/setBosCollectCnt', resList ? resList.length : 0)
          this.releaseList = resList.map(obj => {
            const regDate = obj.reg_date.split(' ')
            return {
              ...obj,
              reg_date: `${regDate[0]} ${regDate[1].substring(0, 5)}`
            }
          })
        }
      }
    },
    async callCollectApi (emitParam) {
      const param = {
        ...emitParam,
        atm_id: this.getStoreResultAtmInfoId,
        lgn_dt: this.getJobStartDateTime,
        door_open_dt: this.getDoorOpenDateTime
      }
      const formData = new FormData()
      for (let item in param) {
        if (item === 'image_files') {
          param[item].forEach(file => {
            formData.append(`${item}`, file)
          })
        } else {
          formData.append(`${item}`, param[item])
        }
      }

      const res = await this.$http.post(`/api/purchase/atm/release`,
        formData,
        {
          'Content-Type': 'multipart/form-data'
        }
      )

      if (res) {
        const { data: { result, status } } = res
        if (status === '200') {
          const { msg } = result
          this.$Alert.alert(msg).then(() => {
            this.getreleaseList()
            this.$store.commit('AtmWsStore/setWorkCollectCnt', emitParam.cnt_release)
          })
        }
      }
    },
    handleImageUpload (param) {
      const fileParam = param.files

      const image_files = []

      for (let idx in fileParam) {
        const type = fileParam[idx].type
        if (type) {
          image_files.push(fileParam[idx])
        }
      }

      this.callCollectApi({
        ...param,
        image_files
      })
    },
    showImageModal (fileParam) {
      this.$modal.show('imageViewer', fileParam)
    }
  }
}
</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 5px; /* 셀 간격 설정 */
    margin-top: 2px;
    margin-bottom: 10px;
}
.main .quick-link {
  height: 150px;
}
</style>

<style>
#atm-work .dx-widget input {
  font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/normal/collect/index.vue